import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
import { shareReplay } from 'rxjs/operators';

import { APP_CONFIG } from '../../core/services/app-config.service';
import { Constants } from '../constants/constants';
import { UserService } from '../../core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(
    private http: HttpClient,
    private deviceService: DeviceDetectorService,
    private userService: UserService
  ) { }

  /**
   * Method to get IP Address
   */
  getIPAddress() {
    this.http
      .get(Constants.IPADDRESS_URL)
      .pipe(shareReplay())
      .subscribe({
        next: (success: any) => {
          this.userService.setIpAddress = success.ip;
        }
      });
  }

  /**
   * Method to get current browser
   */
  getCurrentBrowser() {
    const deviceInfo = this.deviceService.getDeviceInfo();
    return deviceInfo.browser;
  }

  /**
  * Method to set http headers for Splunk logging
  * @returns httpOptions
  */
  getHttpHeadersSplunk(): any {
    const transID = this.getTransactionID();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'transactionId': transID,
        'Accept': 'application/json',
        'source': 'dpadminPortal',
        'hostName': APP_CONFIG.DOMAIN
      })
    };
    return httpOptions;
  }

  /**
   * getTransactionID 
   */
  public getTransactionID() {
    const transaction_id = Math.random().toString(36).slice(2, 18);
    return transaction_id;
  }

}
